import { ENV_DEV } from "../../utils/window";
import getAttributeString from "../animate/utils/get-attribute-string";

/**
 * Run selected actions
 * @param {PropertyValueProps} property
 * @param {MainClassProps} main
 * @param {TimelineMapProps | undefined} [timeline]
 * @param {StepProps | undefined} [step]
 * @param {Boolean} [enter]
 */
const runAction = (property, main, timeline, step, enter = true) => {
  /**
   * Action has no `original` name, so it is action that is computed as "initial" of another trigger
   */
  if (!property.get("original")) {
    return;
  }

  /**
   * Target elements with a desired attribute
   */
  const targets = getAttributeString("o_target", property, step, timeline) || [
    main.element,
  ];

  /**
   * Get attribute name to remove
   * @example `data-active`
   */
  const name =
  property.get("action-options")?.get("name") ||
  getAttributeString("o_name", property, step, timeline) ||
  property.get("action-property");

  /**
   * Get attribute values
   */
  const values =
    property.get("action-options")?.get("value") ||
    getAttributeString("o_value", property, step, timeline)

  /**
   * Action function
   */
  const fn = property.get("action-fn");

  /**
   * Attribute name does not exist
   */
  if (ENV_DEV && !name) {
    console.warn(
      `[TorusKit warn]: No attribute name provided in \`${property.get(
        "action-parent"
      )}\` action.`
    );

    return;
  }

  /**
   * Action function not exist
   */
  if (ENV_DEV && !fn) {
    console.warn(
      `[TorusKit warn]: Unknown attribute \`${property.get(
        "action-property"
      )}\` used within \`${property.get("action-parent")}\` action.`
    );

    return;
  }

  /**
   * Run the action function and return the computed value
   */
  return fn(targets, name, values, property, main, enter);
};

export default runAction;
